import {
  IconReactionMehNoBg,
  IconReactionMustHugNoBg,
  IconReactionNahNoBg,
  IconReactionYayNoBg,
  IconReactionMustHug2,
  IconReactionChefsKiss,
  IconReactionMindBlowing,
  IconReactionNeedItNow,
  IconReactionObsessed,
  IconReactionOutOfThisWorld,
  IconReactionTakeMyMoney,
  IconReactionThoughtProvoking,
} from "atoms";
import type { ArtistReview, ProjectReview } from "../types";

const projectReactionsMap: {
  [key in ProjectReview["rating"]]: typeof IconReactionMustHugNoBg;
} = {
  "Must Hug": IconReactionMustHugNoBg,
  Yay: IconReactionYayNoBg,
  Meh: IconReactionMehNoBg,
  Nah: IconReactionNahNoBg,
} as const;

const artistReactionsMap: {
  [key in ArtistReview["rating"]]: typeof IconReactionMustHug2;
} = {
  "Must Hug": IconReactionMustHug2,
  "Chef's kiss": IconReactionChefsKiss,
  "Mind-blowing": IconReactionMindBlowing,
  "Need it now": IconReactionNeedItNow,
  Obsessed: IconReactionObsessed,
  "Out of this world": IconReactionOutOfThisWorld,
  "Take my money": IconReactionTakeMyMoney,
  "Thought-provoking": IconReactionThoughtProvoking,
};

type RatingIconProps = {
  review: ArtistReview | ProjectReview;
} & React.ComponentProps<typeof IconReactionMustHug2>;

function RatingIcon({ review, ...props }: RatingIconProps) {
  let MappedIcon: null | typeof projectReactionsMap["Must Hug"] = null;

  if (review.reviewableType === "ARTIST") {
    MappedIcon = artistReactionsMap[review.rating];
  } else if (review.reviewableType === "PROJECT") {
    MappedIcon = projectReactionsMap[review.rating];
  }

  return MappedIcon ? <MappedIcon {...props} /> : null;
}

export { RatingIcon };
